export interface AgeBySeverityTrendConfig {
  chartNamePrefix: string;
  valueAxisTitle: string;
  selection: string[];
  /** -> filters_config.filters_fields_to_exclude */
  filtersFieldsToExclude: string[];
  /** -> snapshots_filters_config.filters_fields_to_include */
  snapshotsFiltersFieldsToInclude: string[];
}

const TREND_FIELDS = {
  age: "age",
  ticketAge: "ticket_age",
} as const;

const TREND_FILTER_KEYS = {
  age: "remediation_item.age",
  severity: "remediation_item.severity",
  actualStatus: "remediation_item.actual_status",
  ticketStatus: "remediation_item.ticket_status",
} as const;

export const ageBySeverityTrendConfigs = {
  avgAgeBySeverity: {
    chartNamePrefix: "AvgAgeBySeverityTrend",
    valueAxisTitle: "Age",
    selection: [TREND_FIELDS.age],
    filtersFieldsToExclude: [TREND_FILTER_KEYS.severity, TREND_FILTER_KEYS.age],
    snapshotsFiltersFieldsToInclude: [
      TREND_FILTER_KEYS.severity,
      TREND_FILTER_KEYS.age,
    ],
  },
  avgTicketAgeBySeverity: {
    chartNamePrefix: "AvgTicketAgeBySeverityTrend",
    valueAxisTitle: "Ticket Age",
    selection: [TREND_FIELDS.ticketAge],
    filtersFieldsToExclude: [TREND_FILTER_KEYS.actualStatus],
    snapshotsFiltersFieldsToInclude: [TREND_FILTER_KEYS.ticketStatus],
  },
} satisfies Record<string, AgeBySeverityTrendConfig>;
